import GijsController   from './GijsController'
import gijsplorerSounds from './GijsplorerSounds'

class GameItemLocator

  distanceBetweenPoints = (a, b) ->
    Math.sqrt(
      ((a.x - b.x) ** 2) +
      ((a.y - b.y) ** 2) +
      ((a.z - b.z) ** 2)
    )

  getIntensity = (distance, max) ->
    Math.max(max - distance, 0) / max

  constructor: (@gijs, @stop) ->
    @camera = AFRAME.scenes[0].children[1].object3D
    @gijsController = new GijsController(@gijs)
    gijsplorerSounds.playMonsterBeep()
    gijsplorerSounds.playTargetBeep()

  setTargetNode: (node) ->
    @target = node

  tick: ->
    monsterDistance = distanceBetweenPoints(@camera.position, @gijs.position)
    targetDistance = distanceBetweenPoints(@camera.position, @target.position)
    if monsterDistance < 25 or targetDistance < 50

      if monsterDistance < 25
        # game over!
        window.alert('you lose!')
      else if targetDistance < 50
        window.alert('you win!')

      gijsplorerSounds.stopMonsterBeep()
      gijsplorerSounds.stopTargetBeep()
      @stop()


    gijsplorerSounds.monsterBeeps(getIntensity(monsterDistance, 500))
    gijsplorerSounds.targetBeeps(getIntensity(targetDistance, 1000))

    @gijsController.moveGijs(@camera.position)

export default GameItemLocator
